import { render, staticRenderFns } from "./GridVehicleComponent.vue?vue&type=template&id=15b644a8&"
import script from "./GridVehicleComponent.vue?vue&type=script&lang=js&"
export * from "./GridVehicleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports